import { render, staticRenderFns } from "./major_tj.vue?vue&type=template&id=b7eab9b6"
import script from "./major_tj.vue?vue&type=script&lang=js"
export * from "./major_tj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports